export enum SideBarTypes {
    Filters,
    Columns,
    Schedular,
    Exports,
}